
































































































































































































































































































































































































































































































































































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import Api from "@/api";
import FormErrorsMixin from "@/mixins/FormErrors";
import swal from "sweetalert";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/de";

import ViewLoader from "@/components/Common/ViewLoader.vue";
import AlertBox from "@/components/Common/Alerts/AlertBox.vue";
import TextInput from "@/components/Common/Inputs/TextInput.vue";
import InfoButton from "@/components/Common/Buttons/InfoButton.vue";
import Error404 from "@/components/Common/Error404.vue";
import {
  Gender,
  ICategory,
  ICountry,
  ICountryState,
  IFacility,
  IOpeningTime,
  IService
} from "@/interface";
import { AxiosResponse } from "axios";

interface IWeekDay {
  id: number;
  abbr: string;
  name: string;
  checked: boolean;
  starts_at: Date | string | null;
  ends_at: Date | string | null;
}

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    ViewLoader,
    AlertBox,
    TextInput,
    DatePicker,
    InfoButton,
    Error404
  }
})
export default class FacilityGeneralSettings extends Mixins(FormErrorsMixin) {
  public loading = false;
  public updating = false;
  public validatedInputs = [
    "name",
    "short_name",
    "address.country_id",
    "address.state_id",
    "address.city",
    "post_code",
    "address.street_name",
    "address.street_number",
    "address.additional_information",
    "contact_person.title",
    "contact_person.first_name",
    "contact_person.last_name",
    "contact_person.email",
    "contact_person.phone_number.prefix",
    "contact_person.phone_number.number",
    "contact_person.fax_number.prefix",
    "contact_person.fax_number.number"
  ];
  private facilities: Array<IFacility> = [];
  private space = "\xa0";
  private noDataExist = false;
  private selectedFacility: IFacility | null = null;
  private selectedFacilityId: string | null = null;
  private countries: Array<ICountry> = [];
  private serviceCategories: Array<ICategory> = [];
  private starts_at: Date | string | null = null;
  private ends_at: Date | string | null = null;
  private timeFormat = "HH:mm";
  private isDiffDays = false;
  private weekdays: Array<IWeekDay> = [
    {
      id: 0,
      abbr: "MO",
      name: "monday",
      checked: false,
      starts_at: null,
      ends_at: null
    },
    {
      id: 1,
      abbr: "TU",
      name: "tuesday",
      checked: false,
      starts_at: null,
      ends_at: null
    },
    {
      id: 2,
      abbr: "WE",
      name: "wednesday",
      checked: false,
      starts_at: null,
      ends_at: null
    },
    {
      id: 3,
      abbr: "TH",
      name: "thursday",
      checked: false,
      starts_at: null,
      ends_at: null
    },
    {
      id: 4,
      abbr: "FR",
      name: "friday",
      checked: false,
      starts_at: null,
      ends_at: null
    },
    {
      id: 5,
      abbr: "SA",
      name: "saturday",
      checked: false,
      starts_at: null,
      ends_at: null
    },
    {
      id: 6,
      abbr: "SU",
      name: "sunday",
      checked: false,
      starts_at: null,
      ends_at: null
    }
  ];

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.selectedFacilityId = vm.$route.params.id;
      vm.getFacilities(() => {
        if (
          vm.selectedFacilityId !== null &&
          vm.selectedFacilityId !== undefined &&
          vm.selectedFacilityId !== "default"
        ) {
          vm.getFacility(() => {
            vm.getCountries(() => {
              vm.getServices();
            });
          });
        }
      });
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    this.getFacilities(() => {
      if (
        this.selectedFacilityId !== null &&
        this.selectedFacilityId !== undefined &&
        this.selectedFacilityId !== "default"
      ) {
        this.getFacility(() => {
          this.getCountries(() => {
            this.getServices();
          });
        });
      }
    });
    next();
  }

  private toggleCheckbox(type: string, id: number): void {
    if (type === "weekday") {
      this.weekdays[id].checked = !this.weekdays[id].checked;
      if (this.starts_at) {
        this.weekdays[id].starts_at = this.starts_at;
      }
      if (this.ends_at) {
        this.weekdays[id].ends_at = this.ends_at;
      }
    }
    if (
      type === "service" &&
      this.selectedFacility &&
      this.selectedFacility.service_ids
    ) {
      const index = this.selectedFacility.service_ids.indexOf(id);
      if (index > -1) {
        this.selectedFacility.service_ids.splice(index, 1);
      } else {
        this.selectedFacility.service_ids.push(id);
      }
    }
  }

  private setGender(gender: Gender): void {
    if (this.selectedFacility && this.selectedFacility.contact_person) {
      this.selectedFacility.contact_person.gender = gender;
    }
  }

  private getFacilities(successCallback?: any): void {
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint("facilities/simplified");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.facilities = response.data.data || "undefined";
        if (!this.selectedFacilityId || this.selectedFacilityId === "default") {
          this.selectedFacilityId = response.data.data[0].id;
        }
        if (typeof successCallback == "function") {
          successCallback(this.facilities);
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  private getFacility(successCallback?: any): void {
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      "facilities/" + this.selectedFacilityId
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.selectedFacility = response.data.data;
        if (this.selectedFacility) {
          this.selectedFacility.service_ids = response.data.data.services.map(
            (service: IService) => service.id
          );
        }
        this.weekdays = this.weekdays.map(weekday => ({
          ...weekday,
          checked: false,
          starts_at: null,
          ends_at: null
        }));
        response.data.data.opening_times.map(
          (time: IOpeningTime, index: number) => {
            if (index === 0) {
              this.isDiffDays = false;
              if (time.open_time) {
                this.starts_at = time.open_time;
              }
              if (time.close_time) {
                this.ends_at = time.close_time;
              }
            }
            this.weekdays[(time.day as number) - 1].checked = true;
            if (time.open_time) {
              this.weekdays[(time.day as number) - 1].starts_at =
                time.open_time;
            }
            if (time.close_time) {
              this.weekdays[(time.day as number) - 1].ends_at = time.close_time;
            }
            if (
              this.starts_at !== time.open_time ||
              this.ends_at !== time.close_time
            ) {
              this.isDiffDays = true;
              this.starts_at = null;
              this.ends_at = null;
            }
          }
        );
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        console.log(error.response);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private updateFacility(): void {
    if (this.loading || this.updating || !this.selectedFacilityId) {
      return;
    }
    const endpoint: string = this.$partnerEndpoint(
      "facilities/" + this.selectedFacilityId
    );

    this.resetErrors();
    this.updating = true;
    if (this.selectedFacility) {
      this.selectedFacility.opening_times = this.weekdays
        .filter(
          (weekday: IWeekDay) =>
            weekday.starts_at && weekday.ends_at && weekday.checked
        )
        .map(weekday => ({
          day: weekday.id + 1,
          times: [
            {
              open_time: weekday.starts_at,
              close_time: weekday.ends_at
            }
          ]
        }));
    }

    Api()
      .put(endpoint, this.selectedFacility)
      .then(() => {
        this.getFacilities(() => {
          this.getFacility(() => {
            swal({
              title: "Success!",
              text: "The facility was updated.",
              icon: "success"
            });
          });
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private getCountries(successCallback?: any): void {
    Api()
      .get("api/internal/v1/countries")
      .then((response: AxiosResponse) => {
        this.countries = response.data.data;

        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  private getServices(successCallback?: any): void {
    const endpoint: string = this.$partnerEndpoint("service-categories");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.serviceCategories = response.data.data;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  private countryShouldBeSelected(country: ICountry): boolean {
    return (
      this.selectedFacility !== null &&
      this.selectedFacility.address !== undefined &&
      this.selectedFacility.address.country_id == country.id
    );
  }

  private stateShouldBeSelected(state: ICountryState): boolean {
    return (
      this.selectedFacility !== null &&
      this.selectedFacility.address !== undefined &&
      state.id !== undefined &&
      this.selectedFacility.address.state_id == state.id
    );
  }

  get isFemale(): boolean {
    return (
      this.selectedFacility !== null &&
      this.selectedFacility.contact_person !== undefined &&
      this.selectedFacility.contact_person.gender == 2
    );
  }

  get isMale(): boolean {
    return (
      this.selectedFacility !== null &&
      this.selectedFacility.contact_person !== undefined &&
      this.selectedFacility.contact_person.gender == 1
    );
  }

  get facilityName(): string {
    if (typeof this.facilities == "undefined") {
      return "";
    }

    for (var i = 0; i < this.facilities.length; i++) {
      if (
        this.facilities[i].id == parseInt(this.selectedFacilityId || "", 10)
      ) {
        return this.facilities[i].name || "";
      }
    }

    return "";
  }

  get statesOfSelectedCountry(): Array<ICountryState> {
    for (var i = 0; i < this.countries.length; i++) {
      if (
        this.selectedFacility &&
        this.selectedFacility.address &&
        this.countries[i].id != this.selectedFacility.address.country_id
      ) {
        continue;
      }
      if (
        this.countries[i].states !== null &&
        this.countries[i].states !== undefined
      ) {
        return this.countries[i].states || [];
      }
    }

    return [];
  }

  @Watch("selectedFacilityId")
  selectedFacilityIdChanged(selectedFacilityId: number): void {
    this.$router.push({
      name: "FacilityGeneralSettings",
      params: { id: `${selectedFacilityId}` }
    });
  }

  @Watch("starts_at")
  starts_at_changed(starts_at: Date): void {
    if (!this.isDiffDays) {
      this.weekdays.map(weekday => {
        if (weekday.checked) {
          weekday.starts_at = starts_at;
        }
      });
    }
  }

  @Watch("ends_at")
  ends_at_changed(ends_at: Date): void {
    if (!this.isDiffDays) {
      this.weekdays.map(weekday => {
        if (weekday.checked) {
          weekday.ends_at = ends_at;
        }
      });
    }
  }
}
